import { useState } from "react";
import moment from "moment";
import Select from "react-select";
import { ReactSVG } from "react-svg";
import exporticon from "../../../assets/images/export-icon.svg";
import TelerikReporting from "../../../components/TelerikReporting/TelerikReporting";
import useReports from "../../../Hooks/useReports";
import Loading from "../../../components/LoadingPage/Loading";
// import ReportHeader from "../../../components/reportHeader/ReportHeader";

const userStatusList = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const UsersList = () => {
  const [isActiveUser, setIsActiveUser] = useState(userStatusList[0]);
  const [reportKey, setReportKey] = useState(0);
  const { userListExportAPI, userListExportLoading } = useReports();

  const handleStatusChange = (option: any) => {
    setIsActiveUser(option);
    setReportKey(prev => prev + 1);
  };

  const handleUserListExport = async () => {
    try {
      const response = await userListExportAPI({
        isUserActive: isActiveUser.value,
      });
      if (!response) return;

      const blobUrl = URL.createObjectURL(response);
      const fileName = `${localStorage.getItem("profileClientId")?.toUpperCase() ?? "SRX"}_Users_List_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("User List Export Failed:", error);
    }
  };

  return (
    <div className="report-content-wrapper" style={{ height: "100%" }}>
      {/* <ReportHeader reportTitle="SRX Report - List of Users" /> */}

      <div className="report-filter-wrapper">
        <div className="report-filter-item-wrapper">
          {userListExportLoading && <Loading />}

          <div className="filter-item-box">
            <label className="form-label">Status</label>
            <Select
              classNamePrefix="react-select"
              options={userStatusList}
              value={isActiveUser}
              onChange={handleStatusChange}
              placeholder="Select Status"
              isDisabled={userListExportLoading}
            />
          </div>
        </div>

        <div className="report-export-box">
          <button
            type="button"
            className="report-export-btn"
            onClick={handleUserListExport}
            disabled={userListExportLoading}
          >
            <ReactSVG className="svg-box" wrapper="span" src={exporticon} /> Export
          </button>
        </div>
      </div>

      <div className="filter-detail-wrapper" style={{ height: "100%" }}>
        <div className="filter-item-detail-wrapper" style={{ height: "100%" }}>
          <div className="filter-item-detail-table-wrapper" style={{ height: "100%" }}>
            <TelerikReporting
              key={reportKey}
              params={{ isUserActive: isActiveUser.value }}
              reportName="TrinetUserReport.trdp"
              reportEndPoint="reports/listofusers/get"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersList;